import { render } from "./TabBlock.vue?vue&type=template&id=5376eb26"
import script from "./TabBlock.vue?vue&type=script&lang=js"
export * from "./TabBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__